import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Select, { components } from 'react-select';
import Arrow from 'images/arrowdown.svg';

import WP from 'WP';

import Media from 'css/Media';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <StyledArrow isFocused={props.isFocused && !props.hasValue }/>
        </components.DropdownIndicator>
        )
    );
}

const StyledArrow = styled.div`
    background-image: url(${Arrow});
    background-repeat: no-repeat;
    background-size: contain;
    width: 10.22px;
    height: 5.45px;
    transition: transform .2s ease;

    ${props => props.isFocused && css`
        transform: rotate(180deg);
    `}
`

class DropdownList extends Component {
    
    state = {
        isFocused: false,
        hasValue: false,
        valid: true,
        defaultValue: this.props.defaultValue,
    }

    componentDidUpdate(prevProps) {
        if(prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                defaultValue: this.props.defaultValue
            }, () => this.props.onChange(this.props.defaultValue.value))
        }
    }

    handleBlur = () => {
        if(!this.state.hasValue) {
            this.setState({
                valid: false, 
                isFocused: false
        })
        } else {
            this.setState({
                valid: true, 
                isFocused: false
            })
        }
    }

    handleChange = value => {
        this.props.onChange(value);
        this.setState({hasValue: true, defaultValue: null})
    }

    render () {
        const {isFocused, valid, defaultValue } = this.state;
        const {name, value, options, label} = this.props;

        return (
            <Wrapper className={this.props.className}>
                <p>{label}</p>
                <StyledSelect
                    name={name}
                    options={options}
                    value={defaultValue || options.find(a => a.value === value)}
                    onChange={({value}) => this.handleChange(value)}
                    className="select-container"
                    placeholder=""
                    classNamePrefix={'select'}
                    onFocus={() => this.setState({isFocused: true})}
                    onBlur={this.handleBlur}
                    components={{ DropdownIndicator }}
                    isFocused={isFocused}
                    valid={valid}
                />
                {!valid &&
                <ErrorText>{WP.trans.requiredField}</ErrorText>}
            </Wrapper>
        )
    }
}

export default DropdownList


const Wrapper = styled.div`
    color: ${props => props.theme.colors.inputText};

    p {
        ${props => props.theme.fonts.h6}
        
        ${Media.greaterThan('s')`
            padding: 0 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM} ;
        `}
    }
`

const StyledSelect = styled(Select)`

    .select {
        &__control {
            position: relative;
            height: 50px;
            border-radius: 0;
            width: 100%;
            height: 60px;
            border: 1px solid ${props => props.valid ? props.theme.colors.input : props.theme.colors.danger};
            box-shadow: none;
            -webkit-appearance: none;
            border-radius: 0;
            ${props => props.theme.fonts.p};
            padding: 0 25px;
            background-color: ${props => props.theme.colors.negative};
            transition: border .2s ease;
            cursor: pointer;

            &:hover,
            &:focus-within {
                border-color: ${props => props.theme.colors.text};
            }
        }

        &__value-container {
            padding: 0;
        }

        &__indicator {
            &-separator {
                display: none;
            }
            svg {
                fill: ${props => props.theme.colors.input};
            }
        }

        &__menu {
            box-shadow: none;
            border: 1px solid rgba(51,51,51,.2);
            border-radius: 0;

            &-list {
                padding: 0;
            }
        }

        &__option {
            &--is-focused {
                background-color: ${props => props.theme.colors.bg};
                //color: ${props => props.theme.colors.text};

                &:active {
                    background-color: ${props => props.theme.colors.bg};
                    opacity: .7;
                }
            }
            &--is-selected {
                background-color: ${props => props.theme.colors.bg};
                opacity: .7;
                color: ${props => props.theme.colors.text};
            }
        }
    }
`

const ErrorText = styled.span`
    position: absolute;
    color: ${props => props.theme.colors.danger};
    font-size: 14px;
    line-height: 16px;
    padding-top: ${props => props.theme.spacing.contentS};
    

    ${Media.greaterThan('s')`
        font-size: 16px;
        padding: ${props => props.theme.spacing.contentS} 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
    `}
`